export default __webpack_public_path__ + "shoppingBagIcon.3599048b834750c05b08b6b0a2969097.svg";